/* =============================================================================
   CONTROL V2 SPANISH - RECO BY CAROUSEL JS
   JavaScript para el carousel de recomendaciones
   ============================================================================= */

document.addEventListener('DOMContentLoaded', () => {
    const recoCards = document.querySelectorAll('.p-herbs-reco-card');
    const recoPrevButton = document.querySelector('.p-herbs-reco-prev');
    const recoNextButton = document.querySelector('.p-herbs-reco-next');
    const recoProgressIndicator = document.querySelector('.p-herbs-reco-carousel-progress-indicator');
    const recoInnerTrack = document.querySelector('.p-herbs-reco-inner-track');

    // Exit if elements don't exist
    if (!recoCards.length || !recoPrevButton || !recoNextButton || !recoProgressIndicator || !recoInnerTrack) {
        return;
    }

    const recoTotalCards = recoCards.length;
    let recoCurrentIndex = 0;

    // Card width is now 300px
    const cardWidth = 300;

    const showRecoCard = (index) => {
        let translateXValue = -(cardWidth * index);
        // If it's the last card, center it in the container
        if (index === recoTotalCards - 1) {
            // Container width is 390px, card width is 300px
            // The difference is 90px, half of that is 45px to center the card
            translateXValue += 45;
        }
        recoInnerTrack.style.transform = `translateX(${translateXValue}px)`;
        updateRecoProgressBar(index);
    };

    const updateRecoProgressBar = (index) => {
        const progressPercentage = ((index + 1) / recoTotalCards) * 100;
        recoProgressIndicator.style.width = `${progressPercentage}%`;
    };

    recoPrevButton.addEventListener('click', () => {
        recoCurrentIndex = (recoCurrentIndex === 0) ? recoTotalCards - 1 : recoCurrentIndex - 1;
        showRecoCard(recoCurrentIndex);
    });

    recoNextButton.addEventListener('click', () => {
        recoCurrentIndex = (recoCurrentIndex === recoTotalCards - 1) ? 0 : recoCurrentIndex + 1;
        showRecoCard(recoCurrentIndex);
    });

    // Initialize the first card
    showRecoCard(recoCurrentIndex);

    // Touch swipe variables
    let startX = 0;
    let endX = 0;

    const handleTouchStart = (e) => {
        startX = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        endX = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        const threshold = 50; // Minimum distance to qualify as a swipe
        const deltaX = endX - startX;

        if (Math.abs(deltaX) > threshold) {
            if (deltaX > 0) {
                // Swipe right (previous card)
                recoCurrentIndex = (recoCurrentIndex === 0) ? recoTotalCards - 1 : recoCurrentIndex - 1;
            } else {
                // Swipe left (next card)
                recoCurrentIndex = (recoCurrentIndex === recoTotalCards - 1) ? 0 : recoCurrentIndex + 1;
            }
            showRecoCard(recoCurrentIndex);
        }
    };

    // Attach touch event listeners to the carousel
    recoInnerTrack.addEventListener('touchstart', handleTouchStart);
    recoInnerTrack.addEventListener('touchmove', handleTouchMove);
    recoInnerTrack.addEventListener('touchend', handleTouchEnd);
});
